import { useCallback, useEffect, useState } from "react";
import { Toaster, toast } from "sonner";
import { api, formatApiError } from "../../lib/apiClient";
import ImageUpload from "../../components/ImageUpload";

export default function CookieOfMonthManager() {
    const [form, setForm] = useState({ name: "", description: "", image_url: "", price: "" });

    const fetchData = useCallback(async () => {
        try {
            const { data } = await api.get("/admin/settings");
            const cm = data?.cookie_of_month || {};
            setForm({
                name: cm.name || "",
                description: cm.description || "",
                image_url: cm.image_url || "",
                price: cm.price ?? "",
            });
        } catch (_e) {
            // ignore
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const save = async (e) => {
        e.preventDefault();
        try {
            await api.put("/admin/settings/cookie-of-month", {
                name: form.name,
                description: form.description,
                image_url: form.image_url,
                price: form.price === "" ? null : Number(form.price),
            });
            toast.success("Cookie du mois mis à jour");
        } catch (e2) {
            toast.error(formatApiError(e2.response?.data?.detail) || "Erreur");
        }
    };

    return (
        <div data-testid="admin-cookie-month-page">
            <Toaster richColors position="top-center" />
            <p className="section-tag">administration</p>
            <h1 className="font-serif-display text-4xl text-[#2A1408] tracking-tight">
                Cookie du mois
            </h1>
            <p className="text-[#5C3D2E] mt-2">
                Configurez ici un cookie spécial qui s’affichera en page d’accueil et sur la
                carte. Vous pouvez aussi cocher « Cookie du mois » sur un article existant
                de la carte ; il prendra alors la priorité.
            </p>

            <form onSubmit={save} className="brand-card p-6 mt-6 grid md:grid-cols-2 gap-4">
                <label className="md:col-span-2 text-xs uppercase tracking-widest text-[#5C3D2E]">
                    Nom
                    <input
                        value={form.name}
                        onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
                        className="mt-1 w-full bg-white border border-[#E4D1BB] rounded-md px-3 py-2 text-sm"
                        data-testid="cm-name"
                    />
                </label>
                <label className="md:col-span-2 text-xs uppercase tracking-widest text-[#5C3D2E]">
                    Description
                    <textarea
                        rows={3}
                        value={form.description}
                        onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))}
                        className="mt-1 w-full bg-white border border-[#E4D1BB] rounded-md px-3 py-2 text-sm"
                    />
                </label>
                <label className="md:col-span-2 text-xs uppercase tracking-widest text-[#5C3D2E]">
                    Photo (carré 1:1 recommandé)
                    <div className="mt-1">
                        <ImageUpload
                            value={form.image_url}
                            onChange={(url) => setForm((f) => ({ ...f, image_url: url }))}
                            label=""
                        />
                    </div>
                </label>
                <label className="md:col-span-2 text-xs uppercase tracking-widest text-[#5C3D2E]">
                    Prix (€, optionnel)
                    <input
                        type="number"
                        step="0.01"
                        value={form.price}
                        onChange={(e) => setForm((f) => ({ ...f, price: e.target.value }))}
                        className="mt-1 w-full bg-white border border-[#E4D1BB] rounded-md px-3 py-2 text-sm"
                    />
                </label>
                <div className="md:col-span-2">
                    <button type="submit" className="brand-btn" data-testid="cm-save">
                        Enregistrer
                    </button>
                </div>
            </form>
        </div>
    );
}
